import React from 'react'
import { MinusIcon, TickIcon } from '@fourthwall/icons'

import { Icon } from '../../../common/Icon'
import * as S from './CheckboxIcon.styled'
import { TICK_ICON_SIZE } from './consts'
import type { CheckboxIconProps } from './types'

export const CheckboxIcon = ({ size = 'medium', indeterminate }: CheckboxIconProps) => (
  <S.Container $size={size} aria-hidden="true">
    {indeterminate ? (
      <Icon component={MinusIcon} height={TICK_ICON_SIZE[size]} />
    ) : (
      <Icon component={TickIcon} height={TICK_ICON_SIZE[size]} />
    )}
  </S.Container>
)
